'use strict';
define([
    'angular',
    'modules/keywordtracker/settings/add-keywords/add-keywords.controller'
], function (angular, KeywordTrackerAddKeywordsCtrl) {
    var app = angular.module('app.keywordtracker.settings', []);
    app.controller('KeywordTrackerAddKeywordsCtrl', KeywordTrackerAddKeywordsCtrl);
    return app;
});
